<!-- Start: Single choice -->
<app-element-container
  [element]="element"
  [index]="index"
  [hasEntries]="hasEntries"
  [allElements]="allElements"
  [showCompletionWarning]="showCompletionWarning"
  (remove)="elementRemove.emit(element)"
  (manage)="elementManage.emit(element)"
  (moveUp)="elementMoveUp.emit(element)"
  (moveDown)="elementMoveDown.emit(element)"
  (addMessage)="messageAdd.emit(element)"
  (editMessage)="messageEdit.emit($event)"
  (removeMessage)="messageRemove.emit($event)"
  (visibilityEdit)="visibilityEdit.emit(element)">
  <div class="form-element-answer element-single-choice">
    <div class="element-option" *ngFor="let option of element.options">
      <input type="radio" [value]="option.id" [name]="element.name()" />
      <label>{{ option.text }}</label>
    </div>
  </div>
</app-element-container>
<!-- End: Single choice -->
